import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../utils/theme';
import { device } from '../utils/mediaQueries';

const EducationSection = styled.section`
  padding: 80px 20px;
  background: ${theme.cardBackground};
  color: ${theme.text};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${device.tablet} {
    padding: 100px 40px;
  }

  ${device.laptop} {
    padding: 120px 60px;
  }
`;

const Container = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  margin-bottom: 1rem;
  color: ${theme.white};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const Subtitle = styled(motion.p)`
  color: ${theme.secondary};
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  margin-bottom: 2.5rem;
  letter-spacing: 0.05em;
  
  ${device.tablet} {
    font-size: 1rem;
    margin-bottom: 3rem;
  }
`;

const EducationList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  max-width: 650px;
  margin: 0 auto;

  ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
`;

const EducationCard = styled(motion.div)`
  background: ${theme.background};
  border-radius: 12px;
  padding: 1.5rem;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: ${theme.transition};

  ${device.tablet} {
    padding: 1.75rem;
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-4px);
  }
`;

const Degree = styled.h3`
  font-size: 1.05rem;
  color: ${theme.white};
  margin-bottom: 0.6rem;
  font-weight: 600;
  line-height: 1.3;
  
  ${device.tablet} {
    font-size: 1.15rem;
  }
`;

const Institution = styled.p`
  font-size: 0.9rem;
  color: ${theme.secondary};
  margin-bottom: 0.4rem;
  font-family: ${theme.fontMono};
`;

const Year = styled.span`
  font-size: 0.8rem;
  color: ${theme.text};
  font-family: ${theme.fontMono};
  opacity: 0.7;
`;

const Education = () => {
  const educationData = [
    {
      degree: "B.Tech Information Technology",
      institution: "Anna University",
      year: "2022 - 2026"
    },
    {
      degree: "Higher Secondary Education",
      institution: "Kurinchi Matric HSS",
      year: "2021 - 2022"
    }
  ];

  return (
    <EducationSection id="education">
      <Container>
        <Subtitle data-aos="fade-up">
          My academic journey
        </Subtitle>
        <SectionTitle data-aos="fade-up" data-aos-delay="100">
          Education
        </SectionTitle>
        <EducationList>
          {educationData.map((item, index) => (
            <EducationCard
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Degree>{item.degree}</Degree>
              <Institution>{item.institution}</Institution>
              <Year>{item.year}</Year>
            </EducationCard>
          ))}
        </EducationList>
      </Container>
    </EducationSection>
  );
};

export default Education;